module.exports = __webpack_public_path__ + "static/duergar_stone_guard-b07a4c29240bcfbc2892a8b2002a01fd.png";